var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"status-view",class:_vm.statusClass},[_c('i',{class:_vm.statusIcon}),_c('span',[_vm._v(_vm._s(_vm.statusLabel))])])])}
var staticRenderFns = []

export { render, staticRenderFns }